import { put, PrecommitmentUrl, queryKeys } from '@mobi/account/Utils'
import { DepositLimitFrequency } from '@mobi/api-types/index'
import { useMutation } from '@tanstack/react-query'

export type DepositLimitAndAnniversaryRequest = {
  betAccountNumber: number
  optInMarketingIndicator: boolean
  preCommitmentMaxDepositAmount?: number | null
  preCommitmentMaxDepositFrequency?: DepositLimitFrequency | null
  // The CRM API requires these transformations or it will delete any proposed values
  maxBetAmount?: string
  userCreditCardBlockedIndicator?: boolean
  blockPayPalIndicator?: boolean
}

export const useSaveDepositLimitAndAnniversary = () => {
  const { mutate: saveDepositLimitAndAnniversary, status: saveDepositLimitAndAnniversaryStatus } =
    useMutation({
      mutationFn: (preCommitmentDetails: DepositLimitAndAnniversaryRequest): Promise<void | null> =>
        put(
          PrecommitmentUrl.saveDepositLimitAndAnniversary(preCommitmentDetails.betAccountNumber),
          preCommitmentDetails
        ),
      mutationKey: [queryKeys.precommitmentDepositLimit],
    })
  return { saveDepositLimitAndAnniversary, saveDepositLimitAndAnniversaryStatus }
}
